import { MDBIcon, MDBTable, MDBTableBody, MDBTableHead } from 'mdb-react-ui-kit';
import { useContext } from 'react';
import useResumeLanguageSkillsHandlers from "../../../context/resume/hooks/resume-language-skills-handlers";
import { TranslationContext } from "../../../context/translations/translations-context";
import { useCurrentUserRoles } from "../../../hooks/useCurrentUserRoles";
import useResumeDocumentSection from "../../../hooks/useResumeDocumentSection";
import useResumeProperties from "../../../hooks/useResumeProperties";
import { getNativeLanguageCodes } from "../../../utils/getNativeLanguageCodes";

export default function LanguagesSkillsPreview() {

    const { translations, displayLanguage } = useContext( TranslationContext );
    const { isManagerRole } = useCurrentUserRoles();
    const { isAlcyone, isEuropass } = useResumeProperties();
    const { languageSkills } = useResumeDocumentSection();
    const { handleRemove } = useResumeLanguageSkillsHandlers();
    const nativeLanguageCodes = getNativeLanguageCodes( languageSkills );

    return (
        <>
            <div className="preview" style={ { marginTop: "-15px", overflowX: 'auto' } }>
                { isEuropass && (
                    <div className="d-flex flex-column">
                        <span style={ {
                            fontSize: "11px",
                            color: "#000000"
                        } }>
                            { translations.pdf.nativeLanguagesLabel }{ ' ' }
                            <strong>
                                { languageSkills
                                    .filter( skill => skill.language )
                                    .filter( skill => nativeLanguageCodes.includes( skill.language.code ) )
                                    .sort( ( a, b ) => a.order - b.order )
                                    .map( skill => skill.language?.translations?.[ displayLanguage ] )
                                    .join( ", " ) }
                            </strong>
                        </span>
                        <span style={ {
                            fontSize: "11px",
                            color: "#000000"
                        } }>
                            { translations.pdf.otherLanguagesLabel }
                        </span>
                    </div>
                ) }
                <MDBTable style={ { fontSize: "11px" } }>
                    <MDBTableHead>
                        <tr className="text-center text-white"
                            style={ { backgroundColor: isAlcyone ? "#09B4BF" : "#0B86C8" } }>
                            { isManagerRole && <th style={ isEuropass ? {
                                backgroundColor: "#FFFFFF",
                                color: "#000000"
                            } : null }
                            >
                                { ' ' }
                            </th> }
                            <th style={ isEuropass ? {
                                backgroundColor: "#FFFFFF",
                                color: "#000000"
                            } : null }
                            >
                                { ' ' }
                            </th>
                            <th colSpan="2"
                                className={ isEuropass ? "" : "fw-bold p-1" }
                                style={ isEuropass ? {
                                    backgroundColor: "#FFFFFF",
                                    color: "#000000"
                                } : null }
                            >
                                { isEuropass
                                    ? translations.pdf.comprehensionHeader
                                    : translations.pdf.comprehensionShortHeader }
                            </th>
                            <th colSpan="2"
                                className={ isEuropass ? "" : "fw-bold p-1" } style={ isEuropass ? {
                                backgroundColor: "#FFFFFF",
                                color: "#000000"
                            } : null }
                            >
                                { isEuropass ? translations.pdf.oralExpressionHeader
                                    : translations.pdf.oralExpressionShortHeader }</th>
                            <th colSpan="2"
                                className={ isEuropass ? "" : "fw-bold p-1" } style={ isEuropass ? {
                                backgroundColor: "#FFFFFF",
                                color: "#000000"
                            } : null }
                            >
                                { isEuropass && translations.pdf.writingExpressionHeader }
                            </th>
                        </tr>
                        <tr className="text-black">
                            { isManagerRole && <th>{ ' ' }</th> }
                            <th></th>
                            <th className="text-center p-1" style={ isEuropass ? {
                                backgroundColor: "#FFFFFF",
                                fontSize: "8px"
                            } : null }
                            >
                                { isEuropass ? translations.pdf.listeningComprehensionHeader
                                    : translations.pdf.listeningComprehensionShortHeader }
                            </th>
                            <th className="text-center p-1" style={ isEuropass ? {
                                backgroundColor: "#FFFFFF",
                                fontSize: "8px"
                            } : null }
                            >
                                { isEuropass && translations.pdf.readingComprehensionHeader }
                            </th>
                            <th className="text-center p-1" style={ isEuropass ? {
                                backgroundColor: "#FFFFFF",
                                fontSize: "8px"
                            } : null }
                            >
                                { isEuropass ? translations.pdf.oralInteractionHeader
                                    : translations.pdf.continuousOralExpressionShortHeader }
                            </th>
                            <th className="text-center p-1" style={ isEuropass ? {
                                backgroundColor: "#FFFFFF",
                                fontSize: "8px"
                            } : null }
                            >
                                { isEuropass ? translations.pdf.continuousOralExpressionHeader
                                    : translations.pdf.continuousOralExpressionShortHeader }
                            </th>
                            <th>{ ' ' }</th>
                        </tr>
                    </MDBTableHead>
                    <MDBTableBody style={ { verticalAlign: 'middle' } }>
                        { languageSkills
                            .filter( skill => skill.language )
                            .filter( skill => !isEuropass || !nativeLanguageCodes.includes( skill.language.code ) )
                            .sort( ( a, b ) => a.order - b.order )
                            .map( ( skill, index ) => (
                                <tr key={ index } className='text-black'>
                                    { isManagerRole && (
                                        <th className="p-0">
                                            <MDBIcon
                                                fas
                                                icon="trash-alt"
                                                style={ {
                                                    color: isAlcyone ? "#09B4BF" : "#0B86C8",
                                                    fontSize: "11px",
                                                    width: "2px"
                                                } }
                                                onClick={ () =>  window.confirm(translations.general.confirmationMessage) && handleRemove( skill ) }
                                                role="button"
                                                size="lg"
                                            />
                                        </th>
                                    ) }
                                    <th colSpan="1" className="fw-bold p-1">
                                        <p className="p-0 m-0">{ skill.language?.translations?.[ displayLanguage ] }</p>
                                    </th>
                                    <td className="text-center p-1">
                                        <p className="p-0 m-0">
                                            { skill.listeningComprehensionLevel?.translations?.[ displayLanguage ] }
                                        </p>
                                    </td>
                                    <td className="text-center p-1">
                                        <p className="p-0 m-0">
                                            { skill.readingComprehensionLevel?.translations?.[ displayLanguage ] }
                                        </p>
                                    </td>
                                    <td className="text-center p-1">
                                        <p className="p-0 m-0">
                                            { skill.continuousOralExpressionLevel?.translations?.[ displayLanguage ] }
                                        </p>
                                    </td>
                                    <td className="text-center p-1">
                                        <p className="p-0 m-0">
                                            { skill.oralInteractionLevel?.translations?.[ displayLanguage ] }
                                        </p>
                                    </td>
                                    <td className="text-center p-1">
                                        <p className="p-0 m-0">
                                            { skill.writingExpressionLevel?.translations?.[ displayLanguage ] }
                                        </p>
                                    </td>
                                </tr>
                            ) ) }
                    </MDBTableBody>
                </MDBTable>
                { isEuropass && (
                    <span style={ {
                        fontSize: "11px",
                        color: isEuropass && "#000000",
                        fontStyle: "italic"
                    } }>{ translations.pdf.languageLevelLabel }</span>
                ) }
            </div>
        </>
    );
};
